module.exports = __webpack_public_path__ + "media/images/mobile/abouts/21-a4dbf8e602dbab929a4e6d2a0e5cdfaa.jpg";